import Box from '@mui/material/Box';
import type { ReactNode } from 'react';
import { Icon } from './Icon';

const KEY = { ok: 'success', warn: 'warning', err: 'error', primary: 'primary' } as const;
const ICON = { ok: 'task_alt', warn: 'warning', err: 'error', primary: 'info' } as const;

/** Design alert/banner: tonal background, coloured icon and bold title, body in the default text colour. */
export function Banner({
  tone,
  title,
  children,
  icon,
}: {
  tone: keyof typeof KEY;
  title?: ReactNode;
  children?: ReactNode;
  icon?: string;
}) {
  const key = KEY[tone];
  return (
    <Box
      role={tone === 'err' ? 'alert' : 'status'}
      sx={(t) => ({
        display: 'flex',
        gap: 1.5,
        alignItems: title && children ? 'flex-start' : 'center',
        bgcolor: t.vars.palette[key].container,
        color: t.vars.palette[key].onContainer,
        borderRadius: '8px',
        px: 2,
        py: 1.5,
      })}
    >
      <Icon name={icon ?? ICON[tone]} />
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '2px', minWidth: 0 }}>
        {title && <Box sx={{ fontWeight: 600 }}>{title}</Box>}
        {children && <Box sx={{ fontSize: title ? 13 : 14, color: 'text.primary' }}>{children}</Box>}
      </Box>
    </Box>
  );
}
